'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CustomImage from '@components/CustomImage';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import DynamicButton from '@components/DynamicButton';
import CommonContainer from '@components/CommonContainer';
import cn from './style.module.scss';
export default function WimbledonBridgeBanner(
  props: MarketingPageComponentProps
) {
  return (
    <Stack component="section" className={cn.wimbledonBridgeBanner}>
      <Box className={cn.wimbledonBridgeInner}>
        <Box className={cn.wimbledonBridgeStory}>
          <CustomImage
            src={props.images.wimbledon_bridge_story_banner?.src || ''}
            alt={'BrookGreen Introduction Image'}
            width={768}
            height={768}
          />
        </Box>
        <Box className={cn.wimbledonBridgeContent}>
          <CommonContainer
            maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
            flexGrow={1}
          >
            <Box className={cn.wimbledonContentBlock}>
              <Box className={cn.wimbledonContentText}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['wimbledonBridgeBannerHeading']
                  )}
                </ParallaxText>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    props.locale.section['wimbledonBridgeBannerContent']
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.wimbledonContentButton}>
                <DynamicButton
                  className={cn.wimbledonContentButton__element}
                  children={props.locale.section['wimbledonBridgeBannerButton']}
                  scrollToId="wimbledonBridgeRegistrationID"
                />
              </Box>
            </Box>
          </CommonContainer>
        </Box>
      </Box>
    </Stack>
  );
}
